<template>
  <div class="dia-border grey qulletxt" style="margin-top:20px">
    <div class="title-left u-flex u-row-between">
      <div class="u-flex">
        <div class="head-title-lable">
          <!-- <span class="red">*</span> -->
          分段标题</div>
        <Input maxlength="50" v-model="sobj.value1" placeholder="请输入" style="width: 280px"></Input>
      </div>
      <div class="de-com pot" @click="remove">
        <img src="@/assets/images/del.png" width="18px" height="18px" />
      </div>
    </div>
    <div class="dia-line"></div>
    <div>
      <quillEditor ref="myQuillEditor" v-model="sobj.text" :options="editorOption">

      </quillEditor>
      <input v-show="false" :value="inputvalue" @change="uploadFunc" type="file" name="file" accept="image/*" id="upFilePic" class="up-files">
    </div>
  </div>
</template>

<script>
  import {
    quillEditor
  } from 'vue-quill-editor'
  import ImageResize from 'quill-image-resize-module'
  import * as Quill from 'quill'
  import debounce from '@/util/debounce.js'
  import TableModule from 'quill1-table';
  Quill.register('modules/imageResize', ImageResize)
  Quill.register('modules/table', TableModule);
  //var sizes = [false, '16px', '18px', '20px', '22px', '26px', '28px', '30px']
  const toolbaroption = [
    [{
        table: TableModule.tableOptions()
      },
      {
        table: [
          'insert',
          'append-row-above',
          'append-row-below',
          'append-col-before',
          'append-col-after',
          'remove-col',
          'remove-row',
          'remove-table',
          'split-cell',
          'merge-selection',
          'remove-cell',
          'remove-selection',
          'undo',
          'redo1'
        ]
      },
    ],
    ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
    ['blockquote', 'code-block'], // 引用  代码块
    [{
        header: 1
      }, {
        header: 2
      },
      // { 'header': '3' }
    ], // 1、2 级标题
    [{
      list: 'ordered'
    }, {
      list: 'bullet'
    }], // 有序、无序列表
    [{
      script: 'sub'
    }, {
      script: 'super'
    }], // 上标/下标
    [{
      indent: '-1'
    }, {
      indent: '+1'
    }], // 缩进
    [{
      direction: 'rtl'
    }], // 文本方向
    //[{ size: sizes }], // 配置字号
    // [{
    //   size: ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px', '36px']
    // }], 
    [{
      header: [1, 2, 3, 4, 5, 6]
    }], // 标题
    // [ {
    //   background: []
    // }], // 字体颜色、字体背景颜色
    // [{ font: ['songti'] }], // 字体种类
    [{
      align: []
    }], // 对齐方式
    [{
      color: []
    }, {
      background: []
    }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
    ['clean'], // 清除文本格式
    ['image'], // 链接、图片、视频

  ]
  export default {
    props: ['index', "item"],
    components: {
      quillEditor
    },
    watch: {
      sobj: {
        deep: true,
        handler: function(value) {
          this.charindex++
          if (this.charindex == 1) return
          debounce(() => {
            this.$emit("setData", {
              type: "text",
              index: this.index,
              title: value.value1,
              content: value.text
            })
          }, true)

        }
      }
    },
    data() {
      return {
        inputvalue: "",

        sobj: {
          value1: undefined,
          text: undefined,
        },
        editorOption: {
          modules: {
            toolbar: {
              container: toolbaroption,
              handlers: {
                // image: (value) => {
                 
                //   if (value) {
                  
                //     let input = document.getElementById("upFilePic").click()
                   
                //   }

                // }
              }
            },
            imageResize: {
              displayStyles: {
                backgroundColor: 'black',
                border: 'none',
                color: 'white'
              },
              modules: ['Resize', 'DisplaySize', 'Toolbar']
            },
            table: {
              // table module options
              cellSelectionOnClick: true // true: cell selection on click, false: cell selection with CTRL key
            },
            // add keyboard bindings in Keyboard options
            keyboard: {
              // Since Quill’s default handlers are added at initialization, the only way to prevent them is to add yours in the configuration.
              bindings: {
                backspace: {
                  key: 'backspace',
                  handler: function(range, keycontext) {
                    return TableModule.keyboardHandler(this.quill, 'backspace', range, keycontext);
                  }
                },
                delete: {
                  key: 'delete',
                  handler: function(range, keycontext) {
                    return TableModule.keyboardHandler(this.quill, 'delete', range, keycontext);
                  }
                },
                undo: {
                  ctrlKey: true,
                  key: 'z',
                  handler: function(range, keycontext) {
                    return TableModule.keyboardHandler(this.quill, 'undo', range, keycontext);
                  }
                },
                redo: {
                  ctrlKey: true,
                  shiftKey: true,
                  key: 'z',
                  handler: function(range, keycontext) {
                    return TableModule.keyboardHandler(this.quill, 'redo', range, keycontext);
                  }
                }
              }
            }




          },
          placeholder: '请输入正文'
        },
        charindex: 0
      }
    },
    created() {
  
      this.init()
    },
    methods: {
      uploadFunc() {
        let quill = this.$refs.myQuillEditor.quill;
        this.inputvalue = ""
        let len = document.getElementById("upFilePic").files.length
        if (len == 0) return //

        this.isshow = true
        this.upStatus = "active";


        var myfile = document.getElementById("upFilePic").files[0];
        this.fileName = myfile.name;
        let fileSize = myfile.size;
        // if(myfile) this.uploadLoading = true
        //限制图片5MB以内
        if (fileSize > 1024 * 1024 * 5)
          return this.$Message.info("上传图片不能大于5MB");
        var oMyForm = new FormData();
        oMyForm.append("file", myfile);
        this.$api.asxUpFile("post", "/ocm-admin/file/upload", oMyForm).then(
          (res) => {
            if (res.code === "00000") {
              let src = res.data.url
              let length = quill.getSelection().index;
              // 插入图片  res.info为服务器返回的图片地址
              quill.insertEmbed(length, 'image', src)
              // 调整光标到最后
              quill.setSelection(length + 1)

            }



          }
        );
      },
      init() {
        const {
          text,
          title
        } = this.item
   
        this.sobj = {
          text,
          value1: title
        }
      },
      remove() {
        this.$emit("remove", this.index)
      },
    }
  }
</script>

<style>
  .qulletxt .ql-container {
    height: auto !important;
    min-height: 200px !important;
    font-size: 16px;
  }

  .qulletxt .ql-container p {
    font-size: 1.4em;
  }

  .red {
    color: red;
  }

  em {
    font-style: italic;
  }

  @font-face {
    font-family: 'Font Awesome 6 Free';
    font-style: normal;
    font-weight: 900;
    font-display: block;
    src: url("../../../font/fa-solid-900.woff2") format("woff2"), url("../../../font/fa-solid-900.ttf") format("truetype");
  }
  

.ql-picker-item[data-value="insert"]::after {
  content: "插入表格";
}

.ql-picker-item[data-value="append-col"]::after {
  content: "添加列";
}

.ql-picker-item[data-value="append-col-before"]::after {
  content: "在头部添加列";
}

.ql-picker-item[data-value="append-col-after"]::after {
  content: "在末尾添加列";
}

.ql-picker-item[data-value="remove-col"]::after {
  content: "删除列";
}

.ql-picker-item[data-value="append-row"]::after {
  content: "添加行";
}

.ql-picker-item[data-value="append-row-above"]::after {
  content: "在头部添加行";
}

.ql-picker-item[data-value="append-row-below"]::after {
  content: "在下面添加行";
}

.ql-picker-item[data-value="remove-row"]::after {
  content: "删除行";
}

.ql-picker-item[data-value="split-cell"]::after {
  content: "拆分单元格";
}

.ql-picker-item[data-value="merge-selection"]::after {
  content: "合并所选内容";
}

.ql-picker-item[data-value="remove-cell"]::after {
  content: "删除单元格";
}

.ql-picker-item[data-value="remove-selection"]::after {
  content: "移除选择";
}

.ql-picker-item[data-value="undo"]::after {
  content: "删除所选项目";
}

.ql-picker-item[data-value="redo"]::after {
  content: "初始化";
}

.ql-picker-item[data-value="remove-table"]:before {
  content: "删除表格";
}

</style>